import React, { PureComponent } from 'react';
import ErrorPage from '../ErrorPage';
import PropTypes from 'prop-types';

class ErrorBoundary extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			hasError: false,
		};
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		error?.message
			? this.setState({ errorMessage: error.message, errorInfo: errorInfo })
			: this.setState({ errorMessage: error, errorInfo: errorInfo });
	}

	render() {
		const { hasError, errorMessage, errorInfo } = this.state;
		const { children = <></> } = this.props;
		return hasError ? (
			<ErrorPage errorMessage={errorMessage} errorInfo={errorInfo} />
		) : (
			children
		);
	}
}

ErrorBoundary.propTypes = {
	children: PropTypes.element,
};

export default ErrorBoundary;
